/* about — UX enhancements: favorites / recently viewed / cart recommendations / search suggest / PDP / brand index */
const AF = window.AF || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const store = {
  get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
};
const K = { fav: 'af_fav_v1', recent: 'af_recent_v1', rs: 'af_recent_search_v1' };
const yen = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const root = (AF.root || '/').replace(/\/$/, '');
const setHTML = (el, html) => { if (el && el.dataset.afSig !== html) { el.dataset.afSig = html; el.innerHTML = html; } };

/* ---------- タイトル → ブランド / 商品名 ---------- */
function splitTitle(t = '') {
  const sep = t.includes(' / ') ? ' / ' : t.includes('/') ? '/' : null;
  if (!sep) return { brand: '', name: t.trim() };
  const i = t.indexOf(sep);
  const raw = t.slice(0, i).trim();
  return { brand: raw.split(/[(（]/)[0].trim(), name: t.slice(i + sep.length).trim() };
}
const imgUrl = (u, w = 400) => {
  if (!u) return '';
  let s = typeof u === 'string' ? u : u.src || '';
  if (s.startsWith('//')) s = 'https:' + s;
  return s.includes('?') ? `${s}&width=${w}` : `${s}?width=${w}`;
};
const itemFromJs = (p) => ({
  handle: p.handle, title: p.title, url: `${root}/products/${p.handle}`,
  price: p.price, priceVaries: p.price_varies ?? (p.price_min !== p.price_max),
  available: p.available, image: imgUrl(p.featured_image || (p.images && p.images[0]) || ''), ts: Date.now(),
});
const productCache = new Map();
async function fetchProduct(handle) {
  if (productCache.has(handle)) return productCache.get(handle);
  const pr = fetch(`${root}/products/${encodeURIComponent(handle)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null);
  productCache.set(handle, pr);
  return pr;
}

/* ---------- 小さなカード（JS描画用） ---------- */
function miniCard(it, { remove = false, kind = '' } = {}) {
  const { brand, name } = splitTitle(it.title);
  return `<li class="af-card" data-af-handle="${esc(it.handle)}">
    <a class="af-card__media" href="${esc(it.url)}" tabindex="-1" aria-hidden="true">
      ${it.image ? `<img class="af-card__img" src="${esc(imgUrl(it.image, 480))}" alt="" loading="lazy" width="480" height="600">` : ''}
      ${it.available === false ? '<span class="af-badge">SOLD OUT</span>' : ''}
    </a>
    ${remove
      ? `<button type="button" class="af-x" data-af-remove="${kind}" data-handle="${esc(it.handle)}" aria-label="削除">×</button>`
      : `<button type="button" class="af-heart" data-af-fav="${esc(it.handle)}" aria-pressed="false" aria-label="お気に入りに追加"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.7 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.5 0 5.6 3.3 4.4 6.7-1.7 4.7-9.2 9.3-9.2 9.3z"/></svg></button>`}
    <a class="af-card__info" href="${esc(it.url)}">
      ${brand ? `<span class="af-card__brand">${esc(brand)}</span>` : ''}
      <span class="af-card__name">${esc(name)}</span>
      <span class="af-card__price">${yen(it.price)}${it.priceVaries ? '〜' : ''}</span>
    </a>
  </li>`;
}

/* ---------- トースト ---------- */
let toastTimer;
function toast(html) {
  let t = $('.af-toast');
  if (!t) { t = document.createElement('div'); t.className = 'af-toast'; t.setAttribute('role', 'status'); document.body.append(t); }
  t.innerHTML = html; t.classList.add('is-on');
  clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 2800);
}

/* =========================================================
   お気に入り
   ========================================================= */
const Fav = {
  list() { return store.get(K.fav, []); },
  has(h) { return this.list().some((x) => x.handle === h); },
  save(l) { store.set(K.fav, l.slice(0, 100)); this.sync(); },
  async toggle(handle) {
    const l = this.list();
    const i = l.findIndex((x) => x.handle === handle);
    if (i > -1) { l.splice(i, 1); this.save(l); toast('お気に入りから削除しました'); return false; }
    let it = AF.product && AF.product.handle === handle ? { ...AF.product, image: imgUrl(AF.product.image), ts: Date.now() } : null;
    if (!it) { const p = await fetchProduct(handle); if (!p) return false; it = itemFromJs(p); }
    l.unshift(it); this.save(l);
    toast('お気に入りに追加しました <button type="button" data-af-panel-open="fav">一覧を見る</button>');
    return true;
  },
  sync() {
    const set = new Set(this.list().map((x) => x.handle));
    $$('[data-af-fav]').forEach((b) => {
      const on = set.has(b.dataset.afFav);
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? 'お気に入りから削除' : 'お気に入りに追加');
      const lab = $('[data-af-fav-label]', b); if (lab) lab.textContent = on ? 'お気に入り済み' : 'お気に入り';
    });
    $$('[data-af-fav-count]').forEach((c) => { c.textContent = set.size; c.hidden = set.size === 0; });
    Panel.render();
  },
};

/* =========================================================
   閲覧履歴
   ========================================================= */
const Recent = {
  list() { return store.get(K.recent, []); },
  push(it) {
    const l = this.list().filter((x) => x.handle !== it.handle);
    l.unshift({ ...it, ts: Date.now() }); store.set(K.recent, l.slice(0, 30));
  },
  clear() { store.set(K.recent, []); this.render(); Panel.render(); },
  render() {
    const cur = AF.product && AF.product.handle;
    $$('[data-af-recent]').forEach((sec) => {
      const lim = +sec.dataset.limit || 10;
      const items = this.list().filter((x) => x.handle !== cur).slice(0, lim);
      const ul = $('[data-af-recent-list]', sec);
      sec.hidden = items.length === 0;
      setHTML(ul, items.map((x) => miniCard(x)).join(''));
    });
    Fav.syncButtonsOnly?.();
  },
};
Fav.syncButtonsOnly = () => {
  const set = new Set(Fav.list().map((x) => x.handle));
  $$('[data-af-fav]').forEach((b) => b.setAttribute('aria-pressed', set.has(b.dataset.afFav)));
};

/* =========================================================
   お気に入り・閲覧履歴パネル
   ========================================================= */
const Panel = {
  el: null, tab: 'fav',
  build() {
    if (this.el) return;
    const d = document.createElement('dialog');
    d.className = 'af-panel';
    d.setAttribute('aria-label', 'お気に入り・閲覧履歴');
    d.innerHTML = `<div class="af-panel__inner">
      <div class="af-panel__head">
        <div class="af-tabs" role="tablist">
          <button type="button" role="tab" data-af-tab="fav">FAVORITES <span data-af-fav-count></span></button>
          <button type="button" role="tab" data-af-tab="recent">HISTORY</button>
        </div>
        <button type="button" class="af-panel__close" data-af-panel-close aria-label="閉じる">×</button>
      </div>
      <div class="af-panel__body" data-af-panel-body></div>
      <p class="af-panel__note">お気に入り・閲覧履歴はこのブラウザに保存されます。</p>
    </div>`;
    document.body.append(d);
    d.addEventListener('click', (e) => { if (e.target === d) this.close(); });
    this.el = d;
  },
  open(tab = 'fav') { this.build(); this.tab = tab; this.render(); this.el.showModal(); document.documentElement.classList.add('af-lock'); },
  close() { this.el?.close(); document.documentElement.classList.remove('af-lock'); },
  render() {
    if (!this.el) return;
    $$('[data-af-tab]', this.el).forEach((b) => b.setAttribute('aria-selected', b.dataset.afTab === this.tab));
    const items = this.tab === 'fav' ? Fav.list() : Recent.list();
    const body = $('[data-af-panel-body]', this.el);
    body.innerHTML = items.length
      ? `<ul class="af-grid2" role="list">${items.map((x) => miniCard(x, { remove: true, kind: this.tab })).join('')}</ul>`
      : `<div class="af-empty">${this.tab === 'fav'
          ? '<p>お気に入りはまだありません。</p><p class="af-sub">商品の ♡ をタップすると、ここに保存されます。</p>'
          : '<p>閲覧履歴はまだありません。</p>'}
          <a class="af-btn" href="${root}/collections/new-arrivals">NEW ARRIVAL を見る</a></div>`;
    const c = $('[data-af-fav-count]', this.el); if (c) { const n = Fav.list().length; c.textContent = n ? `(${n})` : ''; c.hidden = false; }
  },
};

/* =========================================================
   Horizon 商品カードに ♡ を付与
   ========================================================= */
const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.7 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.5 0 5.6 3.3 4.4 6.7-1.7 4.7-9.2 9.3-9.2 9.3z"/></svg>';
function decorateCards(scope = document) {
  $$('product-card:not([data-af-done])', scope).forEach((card) => {
    card.dataset.afDone = '1';
    const a = $('a[href*="/products/"]', card);
    if (!a) return;
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const handle = decodeURIComponent(m[1]);
    const host = $('.card-gallery', card) || card;
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'af-heart'; b.dataset.afFav = handle;
    b.setAttribute('aria-pressed', Fav.has(handle)); b.setAttribute('aria-label', 'お気に入りに追加');
    b.innerHTML = HEART;
    host.append(b);
  });
}

/* =========================================================
   商品詳細
   ========================================================= */
function initPDP() {
  if (!AF.product) return;
  Recent.push({ ...AF.product, image: imgUrl(AF.product.image), url: AF.product.url });

  // サイズ表：説明文中の「M：着丈71 身幅50 …」をテーブル化
  const desc = $('[data-af-desc]');
  const sizeWrap = $('[data-af-size-wrap]');
  if (desc && sizeWrap) {
    const lines = desc.innerText.split(/\n+/).map((s) => s.trim()).filter(Boolean);
    const re = /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|F|FREE|ONE ?SIZE|\d{1,2}(?:\.\d)?|[0-9]{2,3}(?:cm)?|[0-9]{1,2}号)\s*[：:]\s*(.+)$/i;
    const rows = []; const used = [];
    lines.forEach((ln) => {
      const m = ln.match(re);
      if (!m) return;
      const cells = [...m[2].matchAll(/([^\s　\d.:：/／]+)\s*[:：]?\s*([\d.]+\s*(?:cm|mm)?)/g)].map((x) => [x[1], x[2]]);
      if (cells.length) { rows.push({ size: m[1], cells }); used.push(ln); }
    });
    if (rows.length) {
      const heads = [...new Set(rows.flatMap((r) => r.cells.map((c) => c[0])))];
      const tbl = `<div class="af-table-wrap"><table class="af-table"><thead><tr><th scope="col">SIZE</th>${heads.map((h) => `<th scope="col">${esc(h)}</th>`).join('')}</tr></thead><tbody>${rows.map((r) => `<tr><th scope="row">${esc(r.size)}</th>${heads.map((h) => { const c = r.cells.find((x) => x[0] === h); return `<td>${c ? esc(c[1].trim()) : '-'}</td>`; }).join('')}</tr>`).join('')}</tbody></table></div><p class="af-sub">単位：cm。平置きで採寸しているため、多少の誤差が生じる場合がございます。</p>`;
      if (!sizeWrap.dataset.afFilled) $('[data-af-size]').innerHTML = tbl;
      sizeWrap.hidden = false;
      // 説明文側のサイズ行は非表示
      const walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
      const kill = [];
      while (walker.nextNode()) {
        const t = walker.currentNode.nodeValue.trim();
        if (!t) continue;
        if (used.some((u) => u.startsWith(t) || t.startsWith(u)) || /^size\s*chart$/i.test(t) || /^[ー―─_\-—]{3,}$/.test(t)) kill.push(walker.currentNode);
      }
      kill.forEach((n) => { const br = n.nextSibling; n.remove(); if (br && br.nodeName === 'BR') br.remove(); });
    }
  }

  // スマホ用 追従カートボタン
  const addBtn = $('product-form-component button[name="add"], button[name="add"], .product-form button[type="submit"]');
  if (addBtn && !document.querySelector('.sticky-add-to-cart__bar, sticky-add-to-cart')) {
    const bar = document.createElement('div');
    bar.className = 'af-sticky';
    const { brand, name } = splitTitle(AF.product.title);
    bar.innerHTML = `<div class="af-sticky__txt"><span>${esc(brand)}</span><b>${esc(name)}</b></div><button type="button" class="af-btn af-btn--solid">${AF.product.available ? 'カートに追加' : 'SOLD OUT'}</button>`;
    if (!AF.product.available) $('button', bar).disabled = true;
    $('button', bar).addEventListener('click', () => {
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { if (!addBtn.disabled) addBtn.click(); }, 450);
    });
    document.body.append(bar);
    new IntersectionObserver(([e]) => {
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(addBtn);
  }
}

/* =========================================================
   カート：送料無料までの残額 ＋ レコメンド
   ========================================================= */
let cartBusy = false;
const cartTargets = () => [
  ...$$('.cart-drawer .cart-drawer__items').map((el) => ({ el, mode: 'append' })),
  ...$$('main cart-items-component').map((el) => ({ el, mode: 'after' })),
];
const extraOf = (t) => (t.mode === 'append' ? t.el : t.el.parentElement).querySelector(':scope > .af-cart-extra');
async function enhanceCart() {
  if (cartBusy) return;
  const anchors = cartTargets();
  if (!anchors.length) return;
  cartBusy = true;
  try {
    const cart = await fetch(`${root}/cart.js`).then((r) => r.json());
    const inCart = new Set(cart.items.map((i) => i.product_id));
    let recos = [];
    if (cart.items.length) {
      const ids = [...inCart].slice(0, 2);
      for (const id of ids) {
        for (const intent of ['complementary', 'related']) {
          const r = await fetch(`${AF.recoUrl || root + '/recommendations/products'}.json?product_id=${id}&limit=10&intent=${intent}`).then((x) => (x.ok ? x.json() : { products: [] })).catch(() => ({ products: [] }));
          recos.push(...(r.products || []));
        }
      }
    } else {
      const r = await fetch(`${root}/collections/new-arrivals/products.json?limit=12`).then((x) => x.json()).catch(() => ({ products: [] }));
      recos = (r.products || []).map((p) => ({ ...p, price: Math.round(parseFloat(p.variants?.[0]?.price || 0) * 100), available: p.variants?.some((v) => v.available), featured_image: p.images?.[0]?.src, variants: p.variants.map((v) => ({ ...v, price: Math.round(parseFloat(v.price) * 100) })) }));
    }
    const seen = new Set();
    recos = recos.filter((p) => p && p.available && !inCart.has(p.id) && !seen.has(p.id) && seen.add(p.id)).slice(0, 8);

    const rest = Math.max(0, (AF.freeShipping || 3300000) - cart.total_price);
    const pct = Math.min(100, Math.round((cart.total_price / (AF.freeShipping || 3300000)) * 100));
    const html = `
      ${cart.items.length ? `<div class="af-ship${rest > 0 ? '' : ' is-done'}" style="--p:${pct}%"><div class="af-ship__row"><span class="af-ship__label">FREE SHIPPING</span><span class="af-ship__msg">${rest > 0 ? `あと <b>${yen(rest)}</b> で送料無料` : '<b>送料無料</b>でお届けします'}</span></div><div class="af-ship__track"><i class="af-ship__fill"></i><span class="af-ship__dot"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h11v9H2zM13 9h4l3 3v3h-7z"/><circle cx="6" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/></svg></span></div><div class="af-ship__scale"><span>¥0</span><span>${yen(AF.freeShipping || 3300000)}</span></div></div>` : ''}
      ${recos.length ? `<div class="af-cart-reco"><p class="af-h af-h--s">${cart.items.length ? 'COMPLETE THE LOOK' : 'NEW ARRIVAL'}</p><ul class="af-cart-reco__list" role="list">${recos.map((p) => {
        const { brand, name } = splitTitle(p.title);
        const av = (p.variants || []).filter((v) => v.available);
        const one = (p.variants || []).length === 1 && av.length === 1;
        return `<li><a href="${esc(p.url || `${root}/products/${p.handle}`)}" class="af-cart-reco__img"><img src="${esc(imgUrl(p.featured_image, 240))}" alt="" loading="lazy" width="120" height="150"></a>
          <div class="af-cart-reco__txt"><span>${esc(brand)}</span><a href="${esc(p.url || `${root}/products/${p.handle}`)}">${esc(name)}</a><b>${yen(p.price)}</b></div>
          ${one ? `<button type="button" class="af-btn af-btn--xs" data-af-quick-add="${av[0].id}">ADD TO CART</button>` : `<a class="af-btn af-btn--xs" href="${esc(p.url || `${root}/products/${p.handle}`)}">SELECT SIZE</a>`}</li>`;
      }).join('')}</ul></div>` : ''}`;

    anchors.forEach((t) => {
      let box = extraOf(t);
      if (!box) {
        box = document.createElement('div'); box.className = 'af-cart-extra';
        if (t.mode === 'append') t.el.append(box); else t.el.insertAdjacentElement('afterend', box);
      }
      box.innerHTML = html;
    });
  } catch (e) { /* noop */ }
  cartBusy = false;
}
async function quickAdd(btn) {
  btn.disabled = true; btn.textContent = '…';
  try {
    const sections = [...new Set($$('cart-items-component[data-section-id]').map((x) => x.dataset.sectionId))];
    const res = await fetch(`${AF.cartAddUrl || root + '/cart/add'}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.dataset.afQuickAdd, quantity: 1 }], sections }),
    }).then((r) => r.json());
    try {
      const { CartAddEvent } = await import('@theme/events');
      const c = await fetch(`${root}/cart.js`).then((r) => r.json());
      document.dispatchEvent(new CartAddEvent({}, 'af-reco', { source: 'af-reco', itemCount: c.item_count, sections: res.sections }));
    } catch (e) { location.reload(); return; }
    btn.textContent = 'ADDED ✓';
    setTimeout(enhanceCart, 600);
  } catch (e) { btn.disabled = false; btn.textContent = 'ADD TO CART'; }
}

/* =========================================================
   検索：最近の検索・閲覧履歴サジェスト
   ========================================================= */
function initSearch() {
  document.addEventListener('submit', (e) => {
    const q = e.target.querySelector?.('input[name="q"]');
    if (!q || !q.value.trim()) return;
    const v = q.value.trim();
    store.set(K.rs, [v, ...store.get(K.rs, []).filter((x) => x !== v)].slice(0, 8));
  }, true);
  const u = new URL(location.href);
  if (AF.template === 'search' && u.searchParams.get('q')) {
    const v = u.searchParams.get('q').trim();
    store.set(K.rs, [v, ...store.get(K.rs, []).filter((x) => x !== v)].slice(0, 8));
  }
  renderSuggest();
}
function renderSuggest() {
  $$('.af-suggest').forEach((box) => {
    const rs = store.get(K.rs, []);
    const g = $('[data-af-recent-searches]', box);
    if (g) {
      g.hidden = !rs.length;
      setHTML($('[data-af-rs-list]', g), rs.map((q) => `<a href="${AF.searchUrl || '/search'}?q=${encodeURIComponent(q)}&type=product">${esc(q)}</a>`).join(''));
    }
    const r = Recent.list().slice(0, 6);
    const rg = $('[data-af-suggest-recent]', box);
    if (rg) {
      rg.hidden = !r.length;
      setHTML($('[data-af-suggest-recent-list]', rg), r.map((it) => {
        const { brand, name } = splitTitle(it.title);
        return `<li><a href="${esc(it.url)}"><img src="${esc(imgUrl(it.image, 160))}" alt="" loading="lazy" width="56" height="70"><span><small>${esc(brand)}</small>${esc(name)}</span></a></li>`;
      }).join(''));
    }
  });
}

/* =========================================================
   ブランド一覧：絞り込み＋A–Z
   ========================================================= */
function initBrands() {
  const wrap = $('[data-af-brands]');
  if (!wrap) return;
  const items = $$('.af-brand', wrap);
  const az = $('[data-af-az]', wrap);
  const inits = [...new Set(items.map((i) => i.dataset.initial))].sort();
  az.innerHTML = inits.map((c) => `<button type="button" data-af-jump="${esc(c)}">${esc(c)}</button>`).join('');
  az.addEventListener('click', (e) => {
    const c = e.target.closest('[data-af-jump]')?.dataset.afJump;
    const t = items.find((i) => i.dataset.initial === c && !i.hidden);
    t?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    t?.classList.add('is-flash'); setTimeout(() => t?.classList.remove('is-flash'), 1200);
  });
  const kana = (s) => s.normalize('NFKC').toLowerCase().replace(/[ァ-ヶ]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0x60));
  $('[data-af-brand-filter]', wrap).addEventListener('input', (e) => {
    const q = kana(e.target.value.trim());
    let n = 0;
    items.forEach((i) => { const hit = !q || kana(i.dataset.afBrandName + ' ' + i.textContent).includes(q); i.hidden = !hit; if (hit) n++; });
    $('[data-af-brand-empty]', wrap).hidden = n > 0;
  });
}

/* ---------- 説明文の折りたたみ ---------- */
function initClamp() {
  $$('[data-af-chead]').forEach((h) => {
    const media = $('[data-af-chead-media]', h);
    const img = $('.af-chead__desc img', h);
    if (media && !media.children.length && img) {
      const im = img.cloneNode(); im.removeAttribute('style'); im.removeAttribute('width'); im.removeAttribute('height'); im.loading = 'eager';
      media.append(im); h.classList.add('af-chead--media');
    }
  });
  $$('[data-af-clamp]').forEach((el) => {
    el.classList.add('is-clamped');
    if (el.scrollHeight <= el.clientHeight + 4) { el.classList.remove('is-clamped'); return; }
    const b = document.createElement('button'); b.type = 'button'; b.className = 'af-more-link'; b.textContent = 'もっと見る';
    b.addEventListener('click', () => { el.classList.remove('is-clamped'); b.remove(); });
    el.after(b);
  });
}

/* ---------- 共通イベント ---------- */
document.addEventListener('click', async (e) => {
  const fav = e.target.closest('[data-af-fav]');
  if (fav) { e.preventDefault(); e.stopPropagation(); fav.classList.add('is-pop'); setTimeout(() => fav.classList.remove('is-pop'), 400); await Fav.toggle(fav.dataset.afFav); return; }
  const op = e.target.closest('[data-af-panel-open]');
  if (op) { e.preventDefault(); Panel.open(op.dataset.afPanelOpen); return; }
  if (e.target.closest('[data-af-panel-close]')) { Panel.close(); return; }
  const tab = e.target.closest('[data-af-tab]');
  if (tab) { Panel.tab = tab.dataset.afTab; Panel.render(); return; }
  const rm = e.target.closest('[data-af-remove]');
  if (rm) {
    const k = rm.dataset.afRemove === 'fav' ? K.fav : K.recent;
    store.set(k, store.get(k, []).filter((x) => x.handle !== rm.dataset.handle));
    Fav.sync(); Recent.render(); return;
  }
  if (e.target.closest('[data-af-recent-clear]')) { Recent.clear(); return; }
  if (e.target.closest('[data-af-rs-clear]')) { store.set(K.rs, []); renderSuggest(); return; }
  const qa = e.target.closest('[data-af-quick-add]');
  if (qa) { e.preventDefault(); quickAdd(qa); return; }
  const sc = e.target.closest('[data-af-scroll]');
  if (sc) { const list = sc.closest('section')?.querySelector('.af-rail__list'); if (list) list.scrollBy({ left: (+sc.dataset.afScroll) * list.clientWidth * 0.8, behavior: 'smooth' }); return; }
  const sh = e.target.closest('[data-af-share]');
  if (sh) {
    const data = { title: sh.dataset.title, url: sh.dataset.url };
    if (navigator.share) { try { await navigator.share(data); } catch (_) {} }
    else { try { await navigator.clipboard.writeText(data.url); toast('URLをコピーしました'); } catch (_) {} }
  }
});
document.addEventListener('close', (e) => { if (e.target === Panel.el) document.documentElement.classList.remove('af-lock'); }, true);


/* =========================================================
   横スクロールの自動送り（ホバー・タッチ・フォーカス中は停止）
   ========================================================= */
function initAutoScroll() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  $$('.ui-test-product-list slideshow-slides, .af-rail__list, .featured-blog-posts slideshow-slides').forEach((t) => {
    if (t.dataset.afAuto) return;
    t.dataset.afAuto = '1';
    let paused = false; let visible = false; let resume;
    const stop = () => { paused = true; clearTimeout(resume); };
    const go = () => { clearTimeout(resume); resume = setTimeout(() => { paused = false; }, 1500); };
    t.addEventListener('pointerenter', stop); t.addEventListener('pointerleave', go);
    t.addEventListener('touchstart', () => { stop(); resume = setTimeout(() => { paused = false; }, 6000); }, { passive: true });
    t.addEventListener('focusin', stop); t.addEventListener('focusout', go);
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: 0.4 }).observe(t);
    setInterval(() => {
      if (paused || !visible || document.hidden) return;
      const max = t.scrollWidth - t.clientWidth;
      if (max <= 8) return;
      const first = t.children[0];
      const cs = getComputedStyle(t);
      const step = first ? first.getBoundingClientRect().width + (parseFloat(cs.columnGap) || 0) : t.clientWidth * 0.25;
      if (t.scrollLeft >= max - 4) t.scrollTo({ left: 0, behavior: 'smooth' });
      else t.scrollBy({ left: step, behavior: 'smooth' });
    }, 3800);
  });
}


/* =========================================================
   サイズ診断（身長・体重・好みのフィット・よく着るブランド）
   ========================================================= */
const SK = 'af_size_profile_v1';
const REF_GROUPS = [
  ['ファスト・ベーシック', ['UNIQLO', 'GU', '無印良品', 'ZARA', 'H&M', 'GAP', 'COS', 'Levi\'s']],
  ['セレクトショップ', ['BEAMS', 'UNITED ARROWS', 'SHIPS', 'JOURNAL STANDARD', 'URBAN RESEARCH', 'nano・universe', 'EDIFICE / IENA', 'freak\'s store']],
  ['スポーツ・アウトドア', ['NIKE', 'adidas', 'THE NORTH FACE', 'Patagonia', 'New Balance', 'Champion']],
  ['ドメスティック', ['COMOLI', 'AURALEE', 'Graphpaper', 'A.PRESSE', 'YOKE', 'KAPTAIN SUNSHINE', 'BISOWN', 'ensou.', 'MOUNTAIN RESEARCH', 'Engineered Garments']],
  ['インポート', ['Maison Margiela', 'MM6 Maison Margiela', 'A.P.C.', 'Acne Studios', 'OUR LEGACY', 'LEMAIRE', 'Ralph Lauren']],
];
const REF_BRANDS = REF_GROUPS.flatMap((g) => g[1]);
/* ブランドごとのサイズ感補正（同表記サイズの胸囲cm差：＋は大きめ、−は小さめ） */
const BRAND_ADJ = { GU: 1, ZARA: -2, 'H&M': 1, GAP: 2, COS: 2, "LEVI'S": 1, 'NANO・UNIVERSE': -1, NIKE: 2, ADIDAS: 2, PATAGONIA: 3, 'NEW BALANCE': 1, CHAMPION: 2, 'RALPH LAUREN': 4, 'A.P.C.': -2, 'ACNE STUDIOS': 2, 'OUR LEGACY': 1, LEMAIRE: 2, GRAPHPAPER: 3, YOKE: 3, COMOLI: 2, AURALEE: 2, 'ENGINEERED GARMENTS': 3, 'MAISON MARGIELA': 1 };
const brandAdj = (b) => BRAND_ADJ[String(b || '').toUpperCase()] || 0;
const REF_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'FREE', '0', '1', '2', '3', '4', '5', '6', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', 'W28', 'W29', 'W30', 'W31', 'W32', 'W33', 'W34', 'W36'];
const LETTER_IDX = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5, '2XL': 5, XXXL: 6, '3XL': 6, F: 2, FREE: 2, 'ONE SIZE': 2, ONESIZE: 2 };
const sizeIdx = (brand, size) => {
  const s = String(size).toUpperCase().trim();
  if (s in LETTER_IDX) return LETTER_IDX[s];
  if (/^W\d+/.test(s)) { const w = parseFloat(s.slice(1)); return Math.max(0, Math.min(6, Math.round((w - 26) / 2))); } // W28=S W30=M W32=L
  const n = parseFloat(s);
  if (isNaN(n)) return 2;
  const b = (brand || '').toUpperCase();
  if (n >= 42) return Math.max(0, Math.min(6, Math.round((n - 44) / 2)));          // 44=XS 46=S 48=M 50=L …
  if (n >= 34) return Math.max(0, Math.min(6, Math.round((n - 34) / 2)));          // 34=XS 36=S 38=M …（レディース）
  if (/AURALEE/.test(b)) return Math.max(0, Math.min(6, n - 2));                   // 3=S 4=M 5=L
  return Math.max(0, Math.min(6, n));                                              // 0=XS 1=S 2=M 3=L 4=XL
};
const CHEST_BY_IDX = { m: [82, 87, 92, 98, 104, 110, 116], f: [74, 78, 83, 88, 93, 98, 103] };

const LABELS = { 身幅: ['身幅', 'バスト', '胸囲', 'width'], 肩幅: ['肩幅', 'shoulder'], 着丈: ['着丈', '総丈', 'length'], 袖丈: ['袖丈', 'sleeve'], 裄丈: ['裄丈', 'ゆき丈'], ウエスト: ['ウエスト', 'waist', 'w'], 股下: ['股下', 'inseam'], 股上: ['股上', 'rise'], ワタリ: ['ワタリ', 'わたり', '渡り', 'thigh'], 裾幅: ['裾幅', 'hem'], ヒップ: ['ヒップ', 'hip'] };
const normLabel = (l) => { const x = l.toLowerCase().replace(/\s/g, ''); for (const k in LABELS) if (LABELS[k].some((a) => x === a.toLowerCase() || x.startsWith(a.toLowerCase()))) return k; return null; };

/* 説明文からサイズ表を抽出 */
function parseSizeChart(text, sizeValues = []) {
  const lines = text.split(/\n+/).map((s) => s.replace(/　/g, ' ').trim()).filter(Boolean);
  const out = [];
  // A: 「M：着丈71 身幅50 …」形式
  const reA = /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|F|FREE|ONE ?SIZE|\d{1,2}(?:\.\d)?|[0-9]{2,3}(?:cm)?|[0-9]{1,2}号)\s*[：:]\s*(.+)$/i;
  lines.forEach((ln) => {
    const m = ln.match(reA); if (!m) return;
    const meas = {};
    [...m[2].matchAll(/([^\s\d.:：/／]+)\s*[:：]?\s*([\d.]+)/g)].forEach((x) => { const k = normLabel(x[1]); if (k) meas[k] = parseFloat(x[2]); });
    if (Object.keys(meas).length) out.push({ size: m[1].toUpperCase(), m: meas });
  });
  if (out.length) return out;
  // B: 「肩幅 : 42.5cm」の行がサイズごとに繰り返す形式
  let cur = null; let curSize = null;
  const sizeSet = new Set(sizeValues.map((v) => String(v).toUpperCase()));
  lines.forEach((ln) => {
    const head = ln.replace(/[【】\[\]（）()]/g, '').replace(/^(サイズ|size)\s*[:：]?\s*/i, '').trim().toUpperCase();
    if (sizeSet.has(head) || /^(SIZE|サイズ)\s*[:：]?\s*\S{1,4}$/i.test(ln)) { if (cur && Object.keys(cur.m).length) out.push(cur); curSize = head; cur = { size: curSize, m: {} }; return; }
    const m = ln.match(/^([^\d:：]{1,8})\s*[:：]\s*([\d.]+)\s*(cm|mm)?/i);
    if (!m) return;
    const k = normLabel(m[1]); if (!k) return;
    if (!cur || k in cur.m) { if (cur && Object.keys(cur.m).length) out.push(cur); cur = { size: null, m: {} }; }
    cur.m[k] = parseFloat(m[2]);
  });
  if (cur && Object.keys(cur.m).length) out.push(cur);
  out.forEach((r, i) => { if (!r.size) r.size = String(sizeValues[i] ?? i + 1).toUpperCase(); });
  return out.length >= 1 ? out : [];
}

/* 体型推定 */
function estimateBody(p) {
  const h = +p.height; const w = +p.weight; const f = p.gender === 'f';
  const std = (f ? 21 : 22) * (h / 100) ** 2; const d = w - std;
  let chest = (f ? 0.52 : 0.53) * h + 0.9 * d;
  if (p.refSize) { const ref = CHEST_BY_IDX[f ? 'f' : 'm'][sizeIdx(p.refBrand, p.refSize)] + brandAdj(p.refBrand); chest = chest * 0.6 + ref * 0.4; }
  return {
    chest, waist: (f ? 0.41 : 0.45) * h + (f ? 1.1 : 1.2) * d, shoulder: (f ? 0.235 : 0.25) * h + 0.15 * d,
    length: 0.40 * h, sleeve: 0.345 * h, inseam: 0.45 * h - 2, hip: (f ? 0.55 : 0.53) * h + 0.8 * d,
  };
}
const FIT = { just: { ease: 10, sh: 0, len: -2, w: 0 }, regular: { ease: 16, sh: 2, len: 0, w: 2 }, loose: { ease: 26, sh: 5, len: 3, w: 4 } };

function recommend(chart, p) {
  if (!chart.length || !p.height || !p.weight) return null;
  const b = estimateBody(p); const f = FIT[p.fit] || FIT.regular;
  const isBottom = chart.some((r) => r.m.ウエスト || r.m.股下);
  const drop = !isBottom && chart.every((r) => !r.m.肩幅 || r.m.肩幅 > b.shoulder + 8);
  const targets = isBottom
    ? { ウエスト: [b.waist + f.w, 1], 股下: [b.inseam, 0.35], ヒップ: [b.hip + f.ease / 2, 0.5] }
    : { 身幅: [(b.chest + f.ease) / 2, 1], 肩幅: [b.shoulder + f.sh, drop ? 0.15 : 0.6], 着丈: [b.length + f.len, 0.35], 袖丈: [b.sleeve, 0.3], 裄丈: [b.shoulder / 2 + b.sleeve, 0.3] };
  const rows = chart.map((r) => {
    let score = 0; let wsum = 0; const notes = [];
    for (const k in targets) {
      let g = r.m[k]; if (g == null) continue;
      if (k === 'ウエスト' && g < 60) g *= 2;
      const [t, wt] = targets[k]; const diff = (g - t) / t;
      score += wt * Math.abs(diff) * (diff < 0 ? 1.7 : 1); wsum += wt;
      const isLen = /丈|股下/.test(k);
      const word = isLen ? (diff < -0.05 ? '短め' : diff > 0.05 ? '長め' : 'ちょうど') : (diff < -0.06 ? '小さめ' : diff < -0.02 ? 'ややタイト' : diff <= 0.05 ? 'ジャスト' : diff <= 0.12 ? 'ゆったり' : 'かなりゆったり');
      notes.push({ k, word, diff });
    }
    return { size: r.size, score: wsum ? score / wsum : 9, notes };
  }).sort((a, z) => a.score - z.score);
  return { best: rows[0], rows, isBottom };
}
function fallbackRec(sizes, p) {
  if (!sizes.length || !p.height) return null;
  const b = estimateBody(p); const arr = CHEST_BY_IDX[p.gender === 'f' ? 'f' : 'm'];
  let idx = arr.findIndex((c) => b.chest + (FIT[p.fit]?.ease || 16) - 16 <= c + 2); if (idx < 0) idx = arr.length - 1;
  const up = sizes.map((s) => String(s).toUpperCase());
  const letters = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  if (up.every((s) => s in LETTER_IDX)) { let c = letters[idx]; if (!up.includes(c)) c = up.reduce((a, s) => (Math.abs(LETTER_IDX[s] - idx) < Math.abs(LETTER_IDX[a] - idx) ? s : a), up[0]); return c; }
  if (up.every((s) => !isNaN(parseFloat(s)))) { const brand = splitTitle(AF.product?.title || '').brand; let best = up[0]; up.forEach((s) => { if (Math.abs(sizeIdx(brand, s) - idx) < Math.abs(sizeIdx(brand, best) - idx)) best = s; }); return best; }
  return null;
}

/* =========================================================
   シューズ用サイズ診断（cm / EU / US / UK を相互換算）
   ========================================================= */
const SK_SHOE = 'af_shoe_profile_v1';
const SHOE_GROUPS = [
  ['スニーカー', ['NIKE', 'adidas', 'New Balance', 'CONVERSE', 'VANS', 'asics', 'Reebok', 'PUMA', 'HOKA', 'Salomon', 'NNormal']],
  ['革靴・ブーツ', ['Dr.Martens', 'RED WING', 'Paraboot', 'GUIDI', 'Tricker\'s', 'CLARKS', 'REGAL', 'Maison Margiela', 'MM6 Maison Margiela']],
  ['サンダル', ['BIRKENSTOCK', 'Teva', 'Suicoke']],
];
/* ブランドの表記サイズと実際の履き心地の差（cm：＋は大きめ＝小さいサイズで合う、−は小さめ） */
const SHOE_ADJ = { NIKE: -0.3, CONVERSE: 0.5, VANS: 0, 'NEW BALANCE': 0, ADIDAS: 0.2, ASICS: 0, PUMA: 0, HOKA: 0, SALOMON: -0.2, 'DR.MARTENS': 0.3, 'RED WING': 0.8, PARABOOT: 0.3, GUIDI: 0, "TRICKER'S": 0.3, CLARKS: 0.3, 'MAISON MARGIELA': 0.2, 'MM6 MAISON MARGIELA': 0.2, BIRKENSTOCK: 0.5 };
const UK_BRANDS = /DR\.?\s?MARTENS|TRICKER|CLARKS|PARABOOT|GRENSON|CHURCH/i;
const shoeAdj = (b) => SHOE_ADJ[String(b || '').toUpperCase()] || 0;
const SHOE_REF_SIZES = [
  ...Array.from({ length: 17 }, (_, i) => `${(22 + i * 0.5).toFixed(1)}cm`),
  ...Array.from({ length: 12 }, (_, i) => `EU ${36 + i}`),
  ...Array.from({ length: 19 }, (_, i) => `US ${4 + i * 0.5}`),
  ...Array.from({ length: 19 }, (_, i) => `UK ${3 + i * 0.5}`),
];
function shoeCm(label, brand = '') {
  const s = String(label).toUpperCase().replace(/\s+/g, ' ').trim();
  const n = parseFloat(s.replace(/[^0-9.]/g, ''));
  if (isNaN(n)) return null;
  if (/CM/.test(s) || (n >= 21 && n <= 31)) return n;
  if (/EU/.test(s) || (n >= 34 && n <= 50)) return n / 1.5 - 1.5;
  if (/UK/.test(s)) return n + 18.5;
  if (/US/.test(s)) return n + 18;
  if (n >= 3 && n <= 14) return UK_BRANDS.test(brand) ? n + 18.5 : n + 18;
  return null;
}
function isShoeProduct() {
  const p = AF.product || {};
  const txt = [p.title, p.type, ...(p.tags || []), ...(p.collections || [])].join(' ');
  if (/BOOT|SHOE|SNEAKER|LOAFER|SANDAL|MULE|DERBY|OXFORD|MOCCASIN|SLIP-?ON|FOOTWEAR|靴|ブーツ|シューズ|スニーカー|サンダル|ローファー|モカシン|ミュール/i.test(txt)) return true;
  const sz = (p.sizes || []).map((s) => parseFloat(String(s).replace(/[^0-9.]/g, '')));
  return sz.length > 1 && sz.every((n) => (n >= 35 && n <= 48) || (n >= 22 && n <= 30.5 && String(n).includes('.')));
}
function shoeRec(sizes, p) {
  if (!sizes.length) return null;
  let base = null;
  if (p.footLen) base = +p.footLen + 1.0;
  else if (p.refSize) { const c = shoeCm(p.refSize, p.refBrand); if (c) base = c - shoeAdj(p.refBrand); }
  if (!base) return null;
  base += p.width === 'wide' ? 0.4 : p.width === 'narrow' ? -0.2 : 0;
  base += p.instep === 'high' ? 0.2 : 0;
  const brand = splitTitle(AF.product?.title || '').brand;
  const target = base - shoeAdj(brand);
  const rows = sizes.map((s) => {
    const c = shoeCm(s, brand); if (c == null) return null;
    const diff = c - target;
    const word = diff < -0.4 ? 'きつめ' : diff < -0.15 ? 'ややタイト' : diff <= 0.3 ? 'ジャスト' : diff <= 0.7 ? 'ややゆとり' : '大きめ';
    return { size: s, cm: c, score: Math.abs(diff) * (diff < 0 ? 1.8 : 1), notes: [{ k: '足長', word }, { k: '目安', word: `${c.toFixed(1)}cm相当` }] };
  }).filter(Boolean).sort((a, z) => a.score - z.score);
  if (!rows.length) return null;
  const best = rows[0];
  if (p.width === 'wide') best.notes.push({ k: 'ワイズ', word: '幅広向けに＋0.5cm寄り' });
  return { size: best.size, rows, notes: best.notes, exact: true, shoe: true, target };
}
function shoeFormHTML() {
  return `<form class="af-size__form" data-af-size-form>
            <p class="af-size__lead">ふだん履いている靴のブランドとサイズ（または足の実寸）から、このシューズのおすすめサイズを算出します。</p>
            <div class="af-size__row"><label>よく履く靴のブランド<span><select name="refBrand"><option value="">選択しない</option>${SHOE_GROUPS.map(([g, bs]) => `<optgroup label="${esc(g)}">${bs.map((b) => `<option>${esc(b)}</option>`).join('')}</optgroup>`).join('')}<option value="その他">その他</option></select></span></label><label>そのサイズ<span><select name="refSize"><option value="">選択しない</option>${SHOE_REF_SIZES.map((s) => `<option>${s}</option>`).join('')}</select></span></label></div>
            <div class="af-size__row"><label>足の実寸（任意）<span><input type="number" name="footLen" min="20" max="32" step="0.1" inputmode="decimal" placeholder="25.5">cm</span></label></div>
            <fieldset class="af-seg"><legend>足幅（ワイズ）</legend><label><input type="radio" name="width" value="narrow"><span>細め</span></label><label><input type="radio" name="width" value="normal" checked><span>ふつう</span></label><label><input type="radio" name="width" value="wide"><span>幅広</span></label></fieldset>
            <fieldset class="af-seg"><legend>甲の高さ</legend><label><input type="radio" name="instep" value="low"><span>低め</span></label><label><input type="radio" name="instep" value="normal" checked><span>ふつう</span></label><label><input type="radio" name="instep" value="high"><span>高め</span></label></fieldset>
            <button type="submit" class="af-btn af-btn--solid">おすすめサイズを見る</button>
          </form>`;
}
function shoeChartHTML(sizes) {
  const brand = splitTitle(AF.product?.title || '').brand;
  const rows = sizes.map((s) => [s, shoeCm(s, brand)]).filter((r) => r[1]);
  if (!rows.length) return '';
  return `<div class="af-table-wrap"><table class="af-table"><thead><tr><th>SIZE</th><th>cm目安</th><th>EU</th><th>US</th><th>UK</th></tr></thead><tbody>${rows.map(([s, c]) => `<tr><th>${esc(s)}</th><td>${c.toFixed(1)}</td><td>${Math.round((c + 1.5) * 1.5)}</td><td>${(Math.round((c - 18) * 2) / 2).toFixed(1)}</td><td>${(Math.round((c - 18.5) * 2) / 2).toFixed(1)}</td></tr>`).join('')}</tbody></table></div><p class="af-sub">換算は一般的な目安です。木型によって履き心地は異なります。</p>`;
}

/* =========================================================
   サイズ表のイラスト（採寸箇所を図示・サイズ切替）
   ========================================================= */
const SD_TOP = {
  svg: `<path class="af-sd__ln" d="M106 58 Q150 74 194 58 L240 72 L290 192 L262 206 L216 124 L214 262 Q150 270 86 262 L84 124 L38 206 L10 192 L60 72 Z"/><path class="af-sd__ln" d="M120 60 Q150 90 180 60"/><path class="af-sd__thin" d="M88 250 L212 250 M266 196 L284 186 M34 196 L16 186"/>`,
  marks: [
    { k: ['肩幅'], d: 'M64 78 L236 78', pill: [3, 6] },
    { k: ['身幅'], d: 'M86 158 L214 158', pill: [3, 40] },
    { k: ['着丈'], d: 'M150 66 L150 262', pill: [3, 86] },
    { k: ['袖丈', '裄丈'], d: 'M244 78 L284 182', pill: [66, 6] },
  ],
};
const SD_BTM = {
  svg: `<path class="af-sd__ln" d="M98 36 L202 36 L202 50 L98 50 Z"/><path class="af-sd__ln" d="M98 50 L84 282 L142 282 L150 120 L158 282 L216 282 L202 50"/><path class="af-sd__thin" d="M150 50 L150 112 M112 50 Q112 72 128 76"/>`,
  marks: [
    { k: ['ウエスト'], d: 'M98 26 L202 26', pill: [34, 0] },
    { k: ['ヒップ'], d: 'M94 92 L206 92', pill: [0, 24], dash: true },
    { k: ['ワタリ'], d: 'M90 128 L150 128', pill: [0, 42] },
    { k: ['股上'], d: 'M238 50 L238 118', pill: [70, 22] },
    { k: ['股下'], d: 'M238 124 L238 282', pill: [70, 62] },
    { k: ['裾幅'], d: 'M84 294 L142 294', pill: [40, 92] },
  ],
};
function sdHTML(chart, rec) {
  if (!chart.length) return '';
  const isBtm = chart.some((r) => r.m.ウエスト || r.m.股下);
  const T = isBtm ? SD_BTM : SD_TOP;
  const mid = 'afA' + Math.random().toString(36).slice(2, 8);
  let idx = Math.max(0, chart.findIndex((r) => String(r.size).toUpperCase() === String(rec || '').toUpperCase()));
  return `<div class="af-sd" data-af-sd data-type="${isBtm ? 'btm' : 'top'}" data-idx="${idx}" data-rec="${esc(rec || '')}">
    <div class="af-sd__stage">
      <svg viewBox="0 0 300 300" aria-hidden="true"><defs><marker id="${mid}" viewBox="0 0 10 10" refX="9" refY="5" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="10" orient="auto-start-reverse"><path d="M1 1 L9 5 L1 9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></marker></defs>
        ${T.svg}
        ${T.marks.map((m, i) => `<path class="af-sd__ar${m.dash ? ' is-dash' : ''}" data-mk="${i}" d="${m.d}" marker-start="url(#${mid})" marker-end="url(#${mid})"/>`).join('')}
      </svg>
      ${T.marks.map((m, i) => `<span class="af-sd__pill" data-pill="${i}" style="left:${m.pill[0]}%;top:${m.pill[1]}%"></span>`).join('')}
    </div>
    <div class="af-sd__nav"><button type="button" class="af-sd__step" data-af-sd-step="-1" aria-label="前のサイズ">←</button><div class="af-sd__chips">${chart.map((r, i) => `<button type="button" data-af-sd-size="${i}">${esc(r.size)}${String(r.size).toUpperCase() === String(rec || '').toUpperCase() ? '<i>おすすめ</i>' : ''}</button>`).join('')}</div><button type="button" class="af-sd__step" data-af-sd-step="1" aria-label="次のサイズ">→</button></div>
    <p class="af-sd__cmp" data-af-sd-cmp></p>
  </div>`;
}
function sdUpdate(el, chart) {
  const isBtm = el.dataset.type === 'btm'; const T = isBtm ? SD_BTM : SD_TOP;
  const idx = Math.min(chart.length - 1, Math.max(0, +el.dataset.idx || 0));
  el.dataset.idx = idx;
  const row = chart[idx]; const recRow = chart.find((r) => String(r.size).toUpperCase() === String(el.dataset.rec).toUpperCase());
  T.marks.forEach((m, i) => {
    const key = m.k.find((k) => row.m[k] != null);
    const pill = $(`[data-pill="${i}"]`, el); const ar = $(`[data-mk="${i}"]`, el);
    const on = key != null; pill.hidden = !on; ar.classList.toggle('is-off', !on);
    if (on) pill.innerHTML = `${key}<b>${row.m[key]}</b>cm`;
  });
  $$('[data-af-sd-size]', el).forEach((b) => b.setAttribute('aria-pressed', +b.dataset.afSdSize === idx));
  const cmp = $('[data-af-sd-cmp]', el);
  if (recRow && recRow !== row) {
    const diffs = Object.keys(row.m).filter((k) => recRow.m[k] != null).map((k) => { const d = Math.round((row.m[k] - recRow.m[k]) * 10) / 10; return d ? `${k} ${d > 0 ? '+' : ''}${d}cm` : null; }).filter(Boolean).slice(0, 4);
    cmp.innerHTML = diffs.length ? `<span>おすすめ ${esc(recRow.size)} と比べて</span>${diffs.join('　')}` : '';
  } else cmp.innerHTML = recRow ? '<span>あなたのおすすめサイズです</span>' : '<span>サイズを切り替えると採寸値が変わります</span>';
}
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-af-sd-size], [data-af-sd-step]'); if (!b) return;
  const el = b.closest('[data-af-sd]'); if (!el) return;
  el.dataset.idx = b.dataset.afSdSize != null ? b.dataset.afSdSize : (+el.dataset.idx + +b.dataset.afSdStep + Size.chart.length) % Size.chart.length;
  sdUpdate(el, Size.chart);
});
function sdRenderAll() { $$('[data-af-sd]').forEach((el) => sdUpdate(el, Size.chart)); }

const Size = {
  el: null, chart: [],
  shoe: false,
  profile() { return store.get(this.shoe ? SK_SHOE : SK, null) || (this.shoe ? { refBrand: '', refSize: '26.5cm', width: 'normal', instep: 'normal', _def: 1 } : { gender: 'm', height: '171', weight: '65', fit: 'regular', _def: 1 }); },
  isDefault() { return !store.get(this.shoe ? SK_SHOE : SK, null); },
  build() {
    if (this.el) return;
    const d = document.createElement('dialog'); d.className = 'af-panel af-size';
    d.setAttribute('aria-label', 'サイズガイド・サイズ診断');
    d.innerHTML = `<div class="af-panel__inner">
      <div class="af-panel__head"><div class="af-tabs" role="tablist"><button type="button" role="tab" data-af-stab="diag" aria-selected="true">サイズ診断</button><button type="button" role="tab" data-af-stab="chart">サイズ表</button><button type="button" role="tab" data-af-stab="how">採寸方法</button></div><button type="button" class="af-panel__close" data-af-size-close aria-label="閉じる">×</button></div>
      <div class="af-panel__body">
        <div data-af-spane="diag">
          ${this.shoe ? shoeFormHTML() : `<form class="af-size__form" data-af-size-form>
            <p class="af-size__lead">身長・体重とふだんのサイズから、このアイテムのおすすめサイズを算出します。</p>
            <fieldset class="af-seg"><legend>性別</legend><label><input type="radio" name="gender" value="m" checked><span>メンズ</span></label><label><input type="radio" name="gender" value="f"><span>レディース</span></label></fieldset>
            <div class="af-size__row"><label>身長<span><input type="number" name="height" min="130" max="210" inputmode="numeric" required placeholder="170">cm</span></label><label>体重<span><input type="number" name="weight" min="30" max="150" inputmode="numeric" required placeholder="60">kg</span></label></div>
            <fieldset class="af-seg"><legend>好みのフィット</legend><label><input type="radio" name="fit" value="just"><span>ジャスト</span></label><label><input type="radio" name="fit" value="regular" checked><span>ふつう</span></label><label><input type="radio" name="fit" value="loose"><span>ゆったり</span></label></fieldset>
            <div class="af-size__row"><label>よく着るブランド<span><select name="refBrand"><option value="">選択しない</option>${REF_GROUPS.map(([g, bs]) => `<optgroup label="${esc(g)}">${bs.map((b) => `<option>${esc(b)}</option>`).join('')}</optgroup>`).join('')}<option value="その他">その他</option></select></span></label><label>そのサイズ<span><select name="refSize"><option value="">選択しない</option>${REF_SIZES.map((s) => `<option>${s}</option>`).join('')}</select></span></label></div>
            <button type="submit" class="af-btn af-btn--solid">おすすめサイズを見る</button>
          </form>`}
          <div class="af-size__result" data-af-size-out></div>
        </div>
        <div data-af-spane="chart" hidden></div>
        <div data-af-spane="how" hidden>${this.shoe ? `<ul class="af-list"><li><b>足長</b>：かかとを壁につけて立ち、かかとから一番長い指先までを測ります</li><li><b>足幅</b>：親指と小指の付け根を結んだ一番広い部分</li><li><b>ポイント</b>：夕方のむくんだ時間に、普段履く靴下で測るのがおすすめです</li></ul><p class="af-sub">スニーカーは足長＋約1cm、革靴・ブーツは足長＋0.5〜1cmが目安です。</p>` : `<ul class="af-list"><li><b>身幅</b>：脇下の縫い目の端から端まで（平置き）</li><li><b>肩幅</b>：左右の肩の縫い目の間</li><li><b>着丈</b>：後ろ襟の付け根から裾まで</li><li><b>袖丈</b>：肩の縫い目から袖口まで</li><li><b>裄丈</b>：後ろ襟の中心から肩を通って袖口まで</li><li><b>ウエスト</b>：ウエスト部分の端から端×2</li><li><b>股下</b>：股の縫い目の交点から裾まで</li></ul><p class="af-sub">平置きで採寸しているため、多少の誤差が生じる場合がございます。お手持ちの服と比べるのがおすすめです。</p>`}</div>
      </div>
      <p class="af-panel__note">診断結果は目安です。迷ったら Instagram DM（@about_fukuoka）でスタッフにご相談ください。</p>
    </div>`;
    document.body.append(d);
    d.addEventListener('click', (e) => { if (e.target === d) this.close(); });
    $('[data-af-size-form]', d).addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = Object.fromEntries(new FormData(e.target));
      store.set(this.shoe ? SK_SHOE : SK, fd); this.renderResult(); this.applyInline(); if (!this.shoe && this.chart.length) { const c = $('[data-af-size]'); if (c) c.innerHTML = this.chartHTML() + '<button type="button" class="af-more-link" data-af-size-open>サイズ診断でおすすめを見る →</button>'; $('[data-af-spane="chart"]', this.el).innerHTML = this.chartHTML(); sdRenderAll(); }
    });
    this.el = d;
  },
  open(tab = 'diag') {
    this.build();
    const p = this.profile();
    if (p) { const f = $('[data-af-size-form]', this.el); Object.entries(p).forEach(([k, v]) => { const el = f.elements[k]; if (!el) return; if (el instanceof RadioNodeList) [...el].forEach((r) => { r.checked = r.value === v; }); else el.value = v; }); this.renderResult(); }
    $('[data-af-spane="chart"]', this.el).innerHTML = this.chartHTML();
    sdRenderAll();
    this.tab(tab); this.el.showModal(); document.documentElement.classList.add('af-lock');
  },
  close() { this.el?.close(); document.documentElement.classList.remove('af-lock'); },
  tab(t) { $$('[data-af-stab]', this.el).forEach((b) => b.setAttribute('aria-selected', b.dataset.afStab === t)); $$('[data-af-spane]', this.el).forEach((p) => { p.hidden = p.dataset.afSpane !== t; }); },
  chartHTML() {
    if (!this.chart.length && this.shoe) { const h = shoeChartHTML(AF.product?.sizes || []); if (h) return h; }
    if (!this.chart.length) return '<p class="af-sub">このアイテムはサイズ表の登録がありません。商品説明をご確認いただくか、DMでお問い合わせください。</p>';
    const heads = [...new Set(this.chart.flatMap((r) => Object.keys(r.m)))];
    return `<div class="af-table-wrap"><table class="af-table"><thead><tr><th>SIZE</th>${heads.map((h) => `<th>${h}</th>`).join('')}</tr></thead><tbody>${this.chart.map((r) => `<tr><th>${esc(r.size)}</th>${heads.map((h) => `<td>${r.m[h] ?? '-'}</td>`).join('')}</tr>`).join('')}</tbody></table></div><p class="af-sub">単位：cm（平置き採寸）</p>${sdHTML(this.chart, this.compute()?.size)}`;
  },
  compute() {
    const p = this.profile(); if (!p) return null;
    if (this.shoe) return shoeRec(AF.product?.sizes || [], p);
    const r = recommend(this.chart, p);
    if (r) return { size: r.best.size, rows: r.rows, notes: r.best.notes, exact: true };
    const s = fallbackRec(AF.product?.sizes || [], p);
    return s ? { size: s, rows: [], notes: [], exact: false } : null;
  },
  renderResult() {
    const out = $('[data-af-size-out]', this.el); if (!out) return;
    const r = this.compute();
    const defNote = this.isDefault() ? `<p class="af-size__def">※ ${this.shoe ? '日本人男性の平均的な足長（約25.5cm）' : '日本人男性の平均（171cm・65kg）'}で仮表示しています。ご自身の数値を入れると、この端末に保存されマイページでも確認できます。</p>` : '<p class="af-size__def is-saved">✓ あなたのサイズ情報はこの端末に保存されています（<a href="/pages/mypage">マイページで確認・編集</a>）</p>';
    if (!r) { out.innerHTML = '<p class="af-sub">このアイテムはサイズ表がないため算出できませんでした。DMでお気軽にご相談ください。</p>'; return; }
    out.innerHTML = defNote + `<div class="af-size__best"><span>${this.isDefault() ? '平均体型でのおすすめサイズ' : 'あなたのおすすめサイズ'}</span><b>${esc(r.size)}</b>${r.exact ? '' : '<small>サイズ表がないため一般的な目安です</small>'}</div>
      ${r.notes.length ? `<ul class="af-size__notes">${r.notes.map((n) => `<li><span>${n.k}</span><b>${n.word}</b></li>`).join('')}</ul>` : ''}
      ${r.rows.length > 1 ? `<div class="af-size__all">${r.rows.slice().sort((a, z) => r.shoe ? a.cm - z.cm : this.chart.findIndex((c) => c.size === a.size) - this.chart.findIndex((c) => c.size === z.size)).map((x) => `<div class="${x.size === r.size ? 'is-best' : ''}"><b>${esc(x.size)}</b><span>${x.notes.filter((n) => /身幅|ウエスト|足長/.test(n.k)).map((n) => n.word).join('') || x.notes.map((n) => n.word)[0] || ''}</span></div>`).join('')}</div>` : ''}`;
  },
  applyInline() {
    const r = this.compute(); const line = $('[data-af-size-result]');
    $$('.af-rec-badge').forEach((b) => b.remove());
    if (!r || !line) { if (line) line.hidden = true; return; }
    const sz = r.notes.filter((n) => /身幅|ウエスト|着丈|股下|足長/.test(n.k)).map((n) => `${n.k}${n.word}`).join('・');
    line.innerHTML = `${this.isDefault() ? (this.shoe ? '平均的な足のサイズの目安' : '平均体型（171cm/65kg）の目安') : 'あなたの目安'}：<b>${esc(r.size)}</b>${sz ? `<span>${sz}</span>` : ''}`; line.hidden = false;
    const idx = AF.product?.sizeIndex ?? -1;
    if (idx > -1) {
      const fs = $$('variant-picker fieldset')[idx] || $$('variant-picker fieldset').find((f) => /サイズ|size/i.test(f.querySelector('legend')?.textContent || ''));
      $$('input[type="radio"]', fs || document).forEach((inp) => {
        if (String(inp.value).toUpperCase() === String(r.size).toUpperCase()) { const lab = inp.closest('label') || document.querySelector(`label[for="${inp.id}"]`); if (lab) { const b = document.createElement('span'); b.className = 'af-rec-badge'; b.textContent = 'おすすめ'; lab.append(b); } }
      });
    }
  },
};
function initSize() {
  if (!AF.product) return;
  Size.shoe = isShoeProduct();
  const desc = $('[data-af-desc]');
  Size.chart = desc ? parseSizeChart(desc.innerText, AF.product.sizes || []) : [];
  const wrap = $('[data-af-size-wrap]');
  if (Size.chart.length && wrap) { $('[data-af-size]').innerHTML = Size.chartHTML() + '<button type="button" class="af-more-link" data-af-size-open>サイズ診断でおすすめを見る →</button>'; wrap.hidden = false; wrap.dataset.afFilled = '1'; sdRenderAll(); }
  Size.applyInline();
}
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-af-size-open]')) { e.preventDefault(); Size.open(Size.profile() ? 'diag' : 'diag'); return; }
  if (e.target.closest('[data-af-size-close]')) { Size.close(); return; }
  const st = e.target.closest('[data-af-stab]'); if (st) Size.tab(st.dataset.afStab);
});
document.addEventListener('close', (e) => { if (e.target === Size.el) document.documentElement.classList.remove('af-lock'); }, true);

/* お問い合わせ：商品名の自動入力（?product=） */
function initContact() {
  const f = $('[data-af-cf-product]'); if (!f) return;
  const q = new URL(location.href).searchParams.get('product'); if (q) f.value = q;
}
/* =========================================================
   スマートレコメンド
   ========================================================= */
const Reco = {
  async fetchList(id, intent, limit = 10) {
    const key = `${id}:${intent}`;
    if (!this.cache) this.cache = new Map();
    if (this.cache.has(key)) return this.cache.get(key);
    const pr = fetch(`${AF.recoUrl || root + '/recommendations/products'}.json?product_id=${id}&limit=${limit}&intent=${intent}`)
      .then((r) => (r.ok ? r.json() : { products: [] })).then((j) => j.products || []).catch(() => []);
    this.cache.set(key, pr);
    return pr;
  },
  profile() {
    const fav = Fav.list(), rec = Recent.list().slice(0, 20);
    const brands = new Map();
    const add = (t, w) => { const b = splitTitle(t).brand.toUpperCase(); if (b) brands.set(b, (brands.get(b) || 0) + w); };
    fav.forEach((x) => add(x.title, 2)); rec.forEach((x, i) => add(x.title, 1 / (1 + i * 0.15)));
    const max = Math.max(1, ...brands.values());
    const prices = [...fav, ...rec].map((x) => x.price).filter((p) => p > 0).sort((a, b) => a - b);
    const median = prices.length ? prices[Math.floor(prices.length / 2)] : 0;
    return { brands, max, median, seen: new Set(rec.map((x) => x.handle)), fav: new Set(fav.map((x) => x.handle)) };
  },
  async seeds(sec) {
    if (sec.dataset.seeds) { const ids = sec.dataset.seeds.split(',').filter(Boolean).slice(0, 4); if (ids.length) return ids.map((id, i) => ({ id: +id, price: 0, type: '', w: 1 / (1 + i * 0.3) })); }
    if (sec.dataset.mode !== 'history' && sec.dataset.productId) return [{ id: +sec.dataset.productId, price: AF.product?.price || 0, type: AF.product?.type || '', w: 1 }];
    const hs = [...Fav.list().slice(0, 2), ...Recent.list().slice(0, 4)].map((x) => x.handle).filter((h, i, a) => a.indexOf(h) === i).slice(0, 4);
    const ps = (await Promise.all(hs.map(fetchProduct))).filter(Boolean);
    return ps.map((p, i) => ({ id: p.id, price: p.price, type: p.type || '', w: 1 / (1 + i * 0.3) }));
  },
  async run(sec) {
    if (sec.dataset.afRecoDone) return; sec.dataset.afRecoDone = '1';
    const limit = +sec.dataset.limit || 12;
    const seeds = await this.seeds(sec);
    if (!seeds.length) return;
    const prof = this.profile();
    const cur = AF.product?.handle;
    const pool = new Map();
    await Promise.all(seeds.flatMap((s) => ['related', 'complementary'].map(async (intent) => {
      const list = await this.fetchList(s.id, intent);
      list.forEach((p, rank) => {
        if (!p || !p.available || p.handle === cur) return;
        const base = (intent === 'related' ? 1 : 0.85) * s.w * (1 - rank * 0.05);
        const e = pool.get(p.handle) || { p, score: 0, hits: 0, seed: s };
        e.score += base; e.hits += 1; pool.set(p.handle, e);
      });
    })));
    const scored = [...pool.values()].map((e) => {
      const { p } = e; const brand = splitTitle(p.title).brand.toUpperCase();
      let s = e.score + Math.min(e.hits - 1, 3) * 0.15;
      s += 0.5 * ((prof.brands.get(brand) || 0) / prof.max);
      const ref = e.seed.price || prof.median;
      if (ref > 0 && p.price > 0) s += 0.35 * Math.exp(-Math.abs(Math.log(p.price / ref)) * 1.6);
      if (e.seed.type && p.type && e.seed.type === p.type) s += 0.1;
      if (prof.seen.has(p.handle)) s -= 0.35;
      if (prof.fav.has(p.handle)) s -= 0.2;
      return { p, s, brand };
    }).sort((a, b) => b.s - a.s);
    const out = [], per = new Map(), cap = 2;
    for (const pass of [cap, Infinity]) {
      for (const x of scored) {
        if (out.length >= limit) break;
        if (out.includes(x)) continue;
        const n = per.get(x.brand) || 0;
        if (x.brand && n >= pass) continue;
        out.push(x); per.set(x.brand, n + 1);
      }
    }
    if (out.length < 4) return;
    setHTML($('[data-af-reco-list]', sec), out.map((x) => miniCard(itemFromJs(x.p))).join(''));
    sec.hidden = false;
    Fav.syncButtonsOnly(); initAutoScroll();
  },
  init() {
    const secs = $$('[data-af-reco]');
    if (!secs.length) return;
    const go = () => secs.forEach((s) => this.run(s));
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 400);
  },
};

/* ---------- メガメニュー：見出し・件数・一覧リンクを付与 ---------- */
function initMega() {
  $$('.menu-list__list-item').forEach((li) => {
    const mm = $('.mega-menu', li);
    if (!mm || mm.dataset.afMega) return;
    mm.dataset.afMega = '1';
    const top = $('.menu-list__link', li);
    const title = (top?.textContent || '').trim();
    const n = $$('.mega-menu__link', mm).length;
    const isBrand = /BRAND/i.test(title);
    const side = document.createElement('div');
    side.className = 'af-mm-side';
    side.innerHTML = `<p class="af-mm-side__kicker">${esc(title)}</p><p class="af-mm-side__count">${n}<span>${isBrand ? 'BRANDS' : 'ITEMS'}</span></p>${top?.getAttribute('href') ? `<a class="af-mm-side__all" href="${esc(top.getAttribute('href'))}">VIEW ALL<span>→</span></a>` : ''}`;
    mm.classList.add('af-mm', isBrand ? 'af-mm--brand' : 'af-mm--cat');
    mm.prepend(side);
  });
}

/* ---------- レイヤードスライドショー：スマホでは全パネルを操作可能に ---------- */
function initLayered() {
  if (!matchMedia('(max-width: 749px)').matches) return;
  $$('.layered-slideshow__panels > [inert]').forEach((p) => p.removeAttribute('inert'));
  $$('.layered-slideshow__panels').forEach((p) => {
    const box = p.closest('.layered-slideshow__container'); if (!box || box.nextElementSibling?.classList.contains('af-swipe')) return;
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'af-swipe'; b.setAttribute('aria-label', '次へスクロール');
    b.innerHTML = '<span class="af-swipe__bar"><i></i></span><span>SWIPE</span><svg viewBox="0 0 24 12" aria-hidden="true"><path d="M0 6h22M17 1l5 5-5 5"/></svg>';
    box.after(b);
    const upd = () => { const m = p.scrollWidth - p.clientWidth; const r = m > 0 ? p.scrollLeft / m : 1; b.style.setProperty('--r', r); b.classList.toggle('is-end', r > .98); };
    p.addEventListener('scroll', upd, { passive: true }); upd();
    b.addEventListener('click', () => {
      const c = p.children[0]; const w = c ? c.getBoundingClientRect().width + 10 : p.clientWidth * .75;
      if (p.scrollLeft + p.clientWidth >= p.scrollWidth - 4) p.scrollTo({ left: 0, behavior: 'smooth' });
      else p.scrollBy({ left: w, behavior: 'smooth' });
    });
  });
}

/* ---------- ヒーロー/特集スライドを画像タップでも遷移 ---------- */
function initSlideLinks() {
  $$('.content-for-layout slideshow-slide, .layered-slideshow__panels > div').forEach((s) => {
    if (s.dataset.afLink) return;
    const a = s.querySelector('a[href]'); if (!a) return;
    s.dataset.afLink = '1'; s.classList.add('af-slide-link');
    let x0 = 0, y0 = 0;
    s.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
    s.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, select, [role="tab"]')) return;
      if (Math.abs(e.clientX - x0) > 10 || Math.abs(e.clientY - y0) > 10) return;
      s.classList.add('af-tapped'); navTo(a.href, a.target);
    });
  });
}

/* ---------- タップ・クリックした手応え（遷移中の細いバー＋押下フィードバック） ---------- */
let navBar;
function navStart() {
  if (!navBar) { navBar = document.createElement('div'); navBar.className = 'af-navbar'; navBar.setAttribute('aria-hidden', 'true'); document.body.appendChild(navBar); }
  navBar.classList.remove('is-on'); void navBar.offsetWidth; navBar.classList.add('is-on');
}
function navTo(href, target) {
  if (target === '_blank') { window.open(href, '_blank', 'noopener'); return; }
  navStart(); location.href = href;
}
function initTapFeedback() {
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]'); if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    setTimeout(() => {
      if (e.defaultPrevented || a.target === '_blank') return;
      const h = a.getAttribute('href') || ''; if (!h || h.startsWith('#') || h.startsWith('tel:') || h.startsWith('mailto:') || h.startsWith('javascript')) return;
      let u; try { u = new URL(a.href); } catch (er) { return; }
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search && u.hash)) return;
      const card = a.closest('product-card, .product-card, .af-card, .af-post, .af-hb__item, li, .af-slide-link');
      if (card) { card.classList.add('af-tapped'); setTimeout(() => card.classList.remove('af-tapped'), 2500); }
      navStart();
    }, 0);
  });
  window.addEventListener('pageshow', () => { navBar && navBar.classList.remove('is-on'); $$('.af-tapped').forEach((x) => x.classList.remove('af-tapped')); });
}

/* ---------- 記事：本文先頭のアイキャッチ重複画像を非表示 ---------- */
function initArticle() {
  const hero = $('.af-article__hero img'); if (!hero) return;
  const key = (s) => (s || '').split('?')[0].split('/').pop().replace(/_\d+x\d*|\.(jpe?g|png|webp)$/gi, '');
  const k = key(hero.currentSrc || hero.src);
  const first = $('.af-article__body img');
  if (first && key(first.currentSrc || first.src) === k) (first.closest('p, figure, .af-article__body div') || first).style.display = 'none';
}

/* =========================================================
   商品画像ライトボックス（拡大・ドラッグで細部確認・スワイプ・簡単に閉じる）
   ========================================================= */
const LB = {
  el: null, imgs: [], i: 0, z: 1, x: 0, y: 0,
  hi(src) { try { const u = new URL(src, location.href); u.searchParams.set('width', '2400'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.toString(); } catch (e) { return src; } },
  collect() {
    const g = $('.product-information media-gallery') || $('media-gallery');
    const seen = new Set(); const list = [];
    $$('.product-media-container img, .product-media img', g || document).filter((im) => !im.closest('dialog, zoom-dialog, [class*="thumbnail"]')).forEach((im) => {
      const s = im.currentSrc || im.src; if (!s || /svg|placeholder/.test(s)) return;
      const k = s.split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); if (seen.has(k)) return; seen.add(k);
      if (im.closest('.af-lb, [class*="thumbnail"]') && list.length) { /* サムネは本画像と重複するので除外 */ }
      list.push({ src: this.hi(s), alt: im.alt || '' });
    });
    return list;
  },
  build() {
    if (this.el) return;
    const d = document.createElement('dialog'); d.className = 'af-lb'; d.setAttribute('aria-label', '商品画像の拡大表示');
    d.innerHTML = `<div class="af-lb__top"><span class="af-lb__count" data-lb-count></span><span class="af-lb__hint">タップ／ダブルタップで拡大・ドラッグで移動</span><button type="button" class="af-lb__close" data-lb-close aria-label="閉じる"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>
      <div class="af-lb__stage" data-lb-stage><img class="af-lb__img" data-lb-img alt="" draggable="false"></div>
      <button type="button" class="af-lb__nav af-lb__nav--prev" data-lb-step="-1" aria-label="前の画像"><svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg></button>
      <button type="button" class="af-lb__nav af-lb__nav--next" data-lb-step="1" aria-label="次の画像"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button>
      <div class="af-lb__thumbs" data-lb-thumbs></div>`;
    document.body.append(d); this.el = d;
    const stage = $('[data-lb-stage]', d); const img = $('[data-lb-img]', d);
    d.addEventListener('click', (e) => {
      if (e.target.closest('[data-lb-close]')) return this.close();
      const st = e.target.closest('[data-lb-step]'); if (st) return this.go(this.i + +st.dataset.lbStep);
      const th = e.target.closest('[data-lb-th]'); if (th) return this.go(+th.dataset.lbTh);
    });
    d.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
    d.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') this.go(this.i + 1); if (e.key === 'ArrowLeft') this.go(this.i - 1); });
    /* ポインター操作：タップで拡大/縮小、拡大中はドラッグで移動、等倍時は左右スワイプで送り・下スワイプで閉じる */
    let sx = 0, sy = 0, ox = 0, oy = 0, moved = false, down = false, lastTap = 0, pts = new Map(), pinch0 = 0, z0 = 1;
    stage.addEventListener('pointerdown', (e) => {
      pts.set(e.pointerId, e); stage.setPointerCapture(e.pointerId); down = true; moved = false; sx = e.clientX; sy = e.clientY; ox = this.x; oy = this.y;
      if (pts.size === 2) { const [a, b] = [...pts.values()]; pinch0 = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); z0 = this.z; }
    });
    stage.addEventListener('pointermove', (e) => {
      if (!down) return; pts.set(e.pointerId, e);
      if (pts.size === 2) { const [a, b] = [...pts.values()]; const dist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); this.zoom(Math.min(4, Math.max(1, z0 * dist / pinch0))); moved = true; return; }
      const dx = e.clientX - sx, dy = e.clientY - sy; if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      if (this.z > 1) { this.x = ox + dx; this.y = oy + dy; this.apply(); }
      else { img.style.transform = `translate(${dx}px, ${Math.max(0, dy)}px)`; img.style.opacity = String(1 - Math.min(.5, Math.max(0, dy) / 400)); }
    });
    const end = (e) => {
      pts.delete(e.pointerId); if (!down) return; if (pts.size) return; down = false;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      if (!moved) {
        const now = Date.now();
        if (this.z > 1) this.zoom(1); else { const r = img.getBoundingClientRect(); this.zoom(2.5, e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2); }
        lastTap = now; return;
      }
      if (this.z === 1) {
        img.style.opacity = '';
        if (dy > 110 && Math.abs(dy) > Math.abs(dx)) return this.close();
        if (Math.abs(dx) > 60) return this.go(this.i + (dx < 0 ? 1 : -1));
        this.apply();
      }
    };
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('wheel', (e) => { e.preventDefault(); this.zoom(Math.min(4, Math.max(1, this.z - e.deltaY * 0.004))); }, { passive: false });
    stage.addEventListener('mousemove', (e) => {
      if (this.z <= 1 || down || matchMedia('(pointer: coarse)').matches) return;
      const r = stage.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
      const iw = img.offsetWidth * (this.z - 1) / 2, ih = img.offsetHeight * (this.z - 1) / 2;
      this.x = -px * 2 * iw; this.y = -py * 2 * ih; this.apply();
    });
  },
  zoom(z, cx = 0, cy = 0) {
    const img = $('[data-lb-img]', this.el);
    if (z <= 1) { this.z = 1; this.x = 0; this.y = 0; } else { const k = z / this.z; this.x = (this.x - cx) * k + cx - cx * (z > this.z ? 1 : 0); this.y = (this.y - cy) * k + cy - cy * (z > this.z ? 1 : 0); this.z = z; }
    this.el.classList.toggle('is-zoom', this.z > 1); this.apply();
  },
  apply() {
    const img = $('[data-lb-img]', this.el);
    const iw = img.offsetWidth * (this.z - 1) / 2, ih = img.offsetHeight * (this.z - 1) / 2;
    this.x = Math.max(-iw, Math.min(iw, this.x)); this.y = Math.max(-ih, Math.min(ih, this.y));
    img.style.transform = `translate(${this.x}px, ${this.y}px) scale(${this.z})`;
  },
  go(i) {
    if (!this.imgs.length) return;
    this.i = (i + this.imgs.length) % this.imgs.length; this.z = 1; this.x = 0; this.y = 0;
    const img = $('[data-lb-img]', this.el); img.classList.add('is-swap');
    const it = this.imgs[this.i];
    const pre = new Image(); pre.onload = pre.onerror = () => { img.src = it.src; img.alt = it.alt; img.style.transform = ''; img.style.opacity = ''; requestAnimationFrame(() => img.classList.remove('is-swap')); };
    pre.src = it.src;
    this.el.classList.remove('is-zoom');
    $('[data-lb-count]', this.el).textContent = `${this.i + 1} / ${this.imgs.length}`;
    $$('[data-lb-th]', this.el).forEach((b) => b.setAttribute('aria-current', +b.dataset.lbTh === this.i));
    $(`[data-lb-th="${this.i}"]`, this.el)?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  },
  open(start = 0) {
    this.build(); this.imgs = this.collect(); if (!this.imgs.length) return;
    $('[data-lb-thumbs]', this.el).innerHTML = this.imgs.map((m, i) => `<button type="button" data-lb-th="${i}" aria-label="${i + 1}枚目"><img src="${esc(m.src.replace('width=2400', 'width=200'))}" alt=""></button>`).join('');
    this.el.classList.toggle('is-single', this.imgs.length < 2);
    this.el.showModal(); document.documentElement.classList.add('af-lock');
    this.go(start);
  },
  close() {
    if (!this.el?.open) return;
    this.el.classList.add('is-closing');
    setTimeout(() => { this.el.close(); this.el.classList.remove('is-closing'); document.documentElement.classList.remove('af-lock'); }, 220);
  },
};
function initLightbox() {
  if (!AF.product) return;
  const g = $('.product-information media-gallery') || $('media-gallery'); if (!g || g.dataset.afLb) return;
  g.dataset.afLb = '1'; g.classList.add('af-lb-ready');
  window.addEventListener('click', (e) => {
    if (!g.contains(e.target) || e.target.closest('dialog, zoom-dialog')) return;
    const img = e.target.closest('.product-media-container')?.querySelector('img') || e.target.closest('img'); if (!img || e.target.closest('[class*="thumbnail"], slideshow-arrows, .slideshow-control')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    const list = LB.collect(); const k = (img.currentSrc || img.src).split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
    LB.open(Math.max(0, list.findIndex((m) => m.src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '') === k)));
  }, true);
}

/* =========================================================
   マイページ（サイズ情報・お気に入り・購入履歴からの提案）
   ========================================================= */
function initMyPage() {
  const root = $('[data-af-mypage]'); if (!root) return;
  const favUl = $('[data-af-my-fav]', root);
  const renderFav = () => { if (!favUl) return; const l = Fav.list().slice(0, 12); favUl.innerHTML = l.length ? l.map((x) => miniCard(x)).join('') : '<li class="af-my__empty">商品の ♡ をタップすると、ここに保存されます。</li>'; Fav.syncButtonsOnly(); };
  renderFav();
  const box = $('[data-af-my-size]', root); if (!box) return;
  const opt = (arr, v) => arr.map((s) => `<option${String(s) === String(v) ? ' selected' : ''}>${esc(s)}</option>`).join('');
  const grp = (groups, v) => `<option value="">選択しない</option>${groups.map(([g, bs]) => `<optgroup label="${esc(g)}">${opt(bs, v)}</optgroup>`).join('')}`;
  const draw = () => {
    const a = store.get(SK, null), s = store.get(SK_SHOE, null);
    const fitL = { just: 'ジャスト', regular: 'ふつう', loose: 'ゆったり' };
    box.innerHTML = `<div class="af-my__sizecards">
      <div class="af-my__sizecard"><p class="af-my__k">APPAREL</p>${a ? `<p class="af-my__v"><b>${esc(a.height)}</b>cm <b>${esc(a.weight)}</b>kg</p><p class="af-my__s">${a.gender === 'f' ? 'レディース' : 'メンズ'}・フィット：${fitL[a.fit] || 'ふつう'}${a.refBrand ? `・${esc(a.refBrand)} ${esc(a.refSize || '')}` : ''}</p>` : '<p class="af-my__s">未登録（商品ページでは平均体型 171cm・65kg で表示）</p>'}</div>
      <div class="af-my__sizecard"><p class="af-my__k">SHOES</p>${s ? `<p class="af-my__v"><b>${esc(s.footLen || s.refSize || '-')}</b>${s.footLen ? 'cm' : ''}</p><p class="af-my__s">${s.refBrand ? esc(s.refBrand) + '・' : ''}足幅：${{ narrow: '細め', normal: 'ふつう', wide: '幅広' }[s.width] || 'ふつう'}</p>` : '<p class="af-my__s">未登録（平均的な足のサイズで表示）</p>'}</div>
    </div>
    <form class="af-my__form" data-af-my-form>
      <fieldset><legend>アパレル</legend>
        <div class="af-my__grid">
          <label>性別<select name="gender"><option value="m"${a?.gender !== 'f' ? ' selected' : ''}>メンズ</option><option value="f"${a?.gender === 'f' ? ' selected' : ''}>レディース</option></select></label>
          <label>身長(cm)<input type="number" name="height" min="130" max="210" inputmode="numeric" value="${esc(a?.height || '')}" placeholder="171"></label>
          <label>体重(kg)<input type="number" name="weight" min="30" max="150" inputmode="numeric" value="${esc(a?.weight || '')}" placeholder="65"></label>
          <label>フィット<select name="fit">${['just', 'regular', 'loose'].map((f) => `<option value="${f}"${(a?.fit || 'regular') === f ? ' selected' : ''}>${fitL[f]}</option>`).join('')}</select></label>
          <label>よく着るブランド<select name="refBrand">${grp(REF_GROUPS, a?.refBrand)}</select></label>
          <label>そのサイズ<select name="refSize"><option value="">選択しない</option>${opt(REF_SIZES, a?.refSize)}</select></label>
        </div>
      </fieldset>
      <fieldset><legend>シューズ</legend>
        <div class="af-my__grid">
          <label>よく履くブランド<select name="s_refBrand">${grp(SHOE_GROUPS, s?.refBrand)}</select></label>
          <label>そのサイズ<select name="s_refSize"><option value="">選択しない</option>${opt(SHOE_REF_SIZES, s?.refSize)}</select></label>
          <label>足の実寸(cm)<input type="number" name="s_footLen" min="20" max="32" step="0.1" inputmode="decimal" value="${esc(s?.footLen || '')}" placeholder="25.5"></label>
          <label>足幅<select name="s_width">${[['narrow', '細め'], ['normal', 'ふつう'], ['wide', '幅広']].map(([v, l]) => `<option value="${v}"${(s?.width || 'normal') === v ? ' selected' : ''}>${l}</option>`).join('')}</select></label>
        </div>
      </fieldset>
      <div class="af-my__actions"><button type="submit" class="af-btn af-btn--solid">保存する</button><span data-af-my-saved></span></div>
    </form>`;
    $('[data-af-my-form]', box).addEventListener('submit', (e) => {
      e.preventDefault(); const fd = Object.fromEntries(new FormData(e.target));
      if (fd.height && fd.weight) store.set(SK, { gender: fd.gender, height: fd.height, weight: fd.weight, fit: fd.fit, refBrand: fd.refBrand, refSize: fd.refSize, t: Date.now() });
      if (fd.s_refSize || fd.s_footLen) store.set(SK_SHOE, { refBrand: fd.s_refBrand, refSize: fd.s_refSize, footLen: fd.s_footLen, width: fd.s_width, instep: 'normal', t: Date.now() });
      draw(); toast('サイズ情報を保存しました');
    });
  };
  draw();
}

/* ---------- 記事：目次の自動生成 ---------- */
function initToc() {
  const nav = $('[data-af-toc]'); const body = $('[data-af-article-body]'); if (!nav || !body) return;
  const hs = $$('h2, h3', body).filter((h) => h.textContent.trim());
  if (hs.length < 2) return;
  $('ol', nav).innerHTML = hs.map((h, i) => { h.id = h.id || `sec-${i + 1}`; return `<li class="is-${h.tagName.toLowerCase()}"><a href="#${h.id}">${esc(h.textContent.trim())}</a></li>`; }).join('');
  nav.hidden = false;
}

/* ---------- 外部リンクは別タブで開く ---------- */
function initExternal(scope = document) {
  $$('a[href^="http"]', scope).forEach((a) => {
    if (a.dataset.afExt) return; a.dataset.afExt = '1';
    try { const u = new URL(a.href); if (u.host === location.host || /(^|\.)about-fukuoka\.com$|myshopify\.com$|shopify\.com$|shop\.app$/.test(u.host)) return; a.target = '_blank'; a.rel = 'noopener noreferrer'; } catch (e) { /* noop */ }
  });
}

/* ---------- 起動 ---------- */
function boot() {
  decorateCards();
  initSize();
  initPDP();
  initContact();
  Recent.render();
  Fav.sync();
  Reco.init();
  initSearch();
  initBrands();
  initClamp();
  initMega();
  setTimeout(initMega, 800);
  initLayered();
  initSlideLinks();
  initTapFeedback();
  initArticle();
  initLightbox();
  initMyPage();
  initToc();
  initExternal();
  enhanceCart();
  initAutoScroll();
  let t;
  new MutationObserver((muts) => {
    clearTimeout(t);
    t = setTimeout(() => {
      decorateCards(); Fav.syncButtonsOnly(); renderSuggest(); initAutoScroll(); initMega(); initExternal(); initSlideLinks();
      const touched = muts.some((m) => {
        const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (!el || el.closest('.af-cart-extra')) return false;
        const nodes = [...m.addedNodes, ...m.removedNodes];
        if (nodes.length && nodes.every((n) => n.nodeType === 1 && n.classList.contains('af-cart-extra'))) return false;
        return !!el.closest('cart-items-component');
      });
      const missing = cartTargets().some((t) => !extraOf(t));
      if (touched || missing) enhanceCart();
    }, 180);
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:update', () => setTimeout(enhanceCart, 400));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
